<template>
    <form @submit.prevent="onSubmit" @keydown="form.errors.clear()">
        <input type="text" class="form-control"
               v-bind:id="generateRandomString() + '-add-categoryname'"
               v-model="form.name">
        <p class="form-text text-danger"  v-text="form.errors.get('name')"></p>
        <button type="submit" class="btn btn-primary btn-sm">Save</button>
    </form>
</template>

<script>

export default {
    name: "AddNewCategoryForm",

    data() {
        return {
            form: new Form(this.element)
        };
    },
    props: {
        element: {}
    },
    methods: {
        onSubmit(){
            this.form.post('/categories')
                .then(category =>  this.$emit('saveChildCategory', category))
        },
        generateRandomString() {
            return Math.random().toString(36).substring(7)
        }
    }
}
</script>

<style scoped>

</style>
